// Centralized API calls for the DarkEdge client

export async function discordLogin(code) {
  const response = await fetch('/api/auth/discord', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ code }),
  });
  return response;
}